import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useParams, useNavigate } from 'react-router-dom'
import './JefeDashboard.css'
import { fetchAuth } from '../../utils/api'
import { FaProjectDiagram, FaChevronLeft, FaChevronDown, FaChevronUp, FaCalendar, FaUsers, FaTasks, FaCheckCircle, FaUndo, FaClock, FaBan, FaPlus, FaTrash, FaEdit, FaChartPie, FaTag, FaListOl, FaTimes, FaExclamationCircle, FaHourglassHalf } from 'react-icons/fa'

export default function JefeProyectoDetalle() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [detalle, setDetalle] = useState(null)
  const [colabs, setColabs] = useState([])
  const [nuevoColabId, setNuevoColabId] = useState('')
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [agregando, setAgregando] = useState(false)
  

  const [taskOpen, setTaskOpen] = useState(false)
  const [taskEtapaId, setTaskEtapaId] = useState(null)
  const [taskNombre, setTaskNombre] = useState('')
  const [taskDesc, setTaskDesc] = useState('')
  const [taskColabIds, setTaskColabIds] = useState([''])
  const [taskFecha, setTaskFecha] = useState('')
  const [taskPrioridad, setTaskPrioridad] = useState('')
  const [taskSaving, setTaskSaving] = useState(false)
  const [etapasCollapsed, setEtapasCollapsed] = useState({})
  const [closingEtapaId, setClosingEtapaId] = useState(null)
  const [reopeningEtapaId, setReopeningEtapaId] = useState(null)
  const [projectClosing, setProjectClosing] = useState(false)
  const [editOpen, setEditOpen] = useState(false)
  const [editLoading, setEditLoading] = useState(false)
  const [editSaving, setEditSaving] = useState(false)
  const [editTaskId, setEditTaskId] = useState(null)
  const [editNombre, setEditNombre] = useState('')
  const [editDesc, setEditDesc] = useState('')
  const [editDescMarkers, setEditDescMarkers] = useState('')
  const [editFecha, setEditFecha] = useState('')
  const [editPrioridad, setEditPrioridad] = useState('')
  const [editEstado, setEditEstado] = useState('')
  const [editColabId, setEditColabId] = useState('')
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [deletingId, setDeletingId] = useState(null)
  const [deleting, setDeleting] = useState(false)
  const [toast, setToast] = useState({ visible: false, type: 'success', title: '', message: '' })

  useEffect(() => {
    if (!toast.visible) return
    const t = setTimeout(() => setToast(prev => ({ ...prev, visible: false })), 3000)
    return () => clearTimeout(t)
  }, [toast.visible])

  const toUIEstado = (estado) => {
    switch (estado) {
      case 'PENDIENTE': return 'Pendiente'
      case 'ACTIVO': return 'En Progreso'
      case 'RECHAZADO': return 'Cancelado'
      default: return estado || 'Pendiente'
    }
  }

  const formatDate = (s) => {
    const a = String(s || '')
    const part = a.split('T')[0].split(' ')[0]
    if (!part) return '-'
    const [y, m, d] = part.split('-')
    return `${d}/${m}/${y}`
  }

  const toDate = (s) => {
    const a = String(s || '')
    const part = a.split('T')[0].split(' ')[0]
    if (!part) return null
    return new Date(part + 'T00:00:00')
  }

  const daysBetween = (a, b) => {
    if (!a || !b) return null
    const ms = b.getTime() - a.getTime()
    return Math.floor(ms / 86400000)
  }

  

  const getEtapaNameById = (eid) => {
    const e = (detalle?.etapas || []).find(x => String(x.id_etapa) === String(eid))
    return e?.nombre || 'Etapa'
  }

  const getTaskNameById = (tid) => {
    for (const e of (detalle?.etapas || [])) {
      const t = (e.items || []).find(it => String(it.id_tarea) === String(tid))
      if (t) return t.nombre || 'Tarea'
    }
    return 'Tarea'
  }

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true)
        setError(null)
        const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
        setDetalle(d)
      } catch (e) {
        setError(e.message || 'Error al cargar detalle')
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [id])

  useEffect(() => {
    let handle = null
    const refresh = async () => {
      try {
        const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
        setDetalle(d)
      } catch {}
      handle = setTimeout(refresh, 4000)
    }
    handle = setTimeout(refresh, 4000)
    return () => { if (handle) clearTimeout(handle) }
  }, [id])

  useEffect(() => {
    const loadCols = async () => {
      try {
        const data = await fetchAuth('/api/jefe/colaboradores/')
        setColabs(data.colaboradores || [])
      } catch {}
    }
    loadCols()
  }, [])

  const yaEnProyecto = (uid) => {
    const lista = detalle?.colaboradores || []
    return !!lista.find(c => String(c.id_usuario) === String(uid))
  }

  const abrirConfirmacion = () => {
    if (!nuevoColabId) return
    setConfirmOpen(true)
  }

  const cerrarConfirmacion = () => setConfirmOpen(false)

  const enviarSolicitud = async () => {
    try {
      setAgregando(true)
      await fetchAuth(`/api/jefe/proyectos/${id}/tareas/crear/`, {
        method: 'POST',
        body: JSON.stringify({
          nombre: 'Solicitud de colaboración',
          descripcion: 'Invitación para participar en el proyecto',
          id_usuario_asignado: parseInt(nuevoColabId, 10)
        })
      })
      const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
      setDetalle(d)
      setNuevoColabId('')
      setConfirmOpen(false)
      const colName = (colabs.find(c => String(c.id_usuario) === String(nuevoColabId)) || {}).nombre || 'colaborador'
      setToast({ visible: true, type: 'success', title: 'Solicitud enviada', message: `Se invitó a ${colName} al proyecto.` })
    } catch (e) {
      const colName = (colabs.find(c => String(c.id_usuario) === String(nuevoColabId)) || {}).nombre || 'colaborador'
      setToast({ visible: true, type: 'error', title: 'No se pudo enviar la solicitud', message: `No se pudo invitar a ${colName}. ${e.message || 'Intenta nuevamente.'}` })
    } finally {
      setAgregando(false)
    }
  }

  

  const crearTareaEnEtapa = async () => {
    try {
      if (!taskNombre.trim() || !taskEtapaId) return
      setTaskSaving(true)
      const activos = (detalle?.colaboradores || []).filter(c => String(c.estado || '').toUpperCase() === 'ACTIVO')
      const seleccionados = (taskColabIds || []).map(v => v && parseInt(v, 10)).filter(Boolean)
      if (seleccionados.length > 0) {
        for (const uid of seleccionados) {
          if (!activos.find(c => String(c.id_usuario) === String(uid))) continue
          await fetchAuth(`/api/jefe/proyectos/${id}/tareas/crear/`, {
            method: 'POST',
            body: JSON.stringify({
              nombre: taskNombre.trim(),
              descripcion: taskDesc || null,
              id_usuario_asignado: uid,
              fecha_termino: taskFecha || null,
              prioridad: taskPrioridad || null,
              id_etapa: taskEtapaId
            })
          })
        }
      } else {
        throw new Error('Selecciona al menos un colaborador para asignar la tarea')
      }
      // Optimistic update: reflejar tarea en la etapa inmediatamente
      setDetalle(prev => {
        if (!prev) return prev
        const next = JSON.parse(JSON.stringify(prev))
        const etapa = (next.etapas || []).find(e => String(e.id_etapa) === String(taskEtapaId))
        if (etapa) {
          const colName = (uid => {
            const c = (prev.colaboradores || []).find(x => String(x.id_usuario) === String(uid))
            return c?.nombre || ''
          })
      const ids = seleccionados.length ? seleccionados : []
      ids.forEach(uid => {
        etapa.items.push({
          id_tarea: `tmp_${Date.now()}`,
          nombre: taskNombre.trim(),
          estado: 'Pendiente',
          prioridad: taskPrioridad || null,
          fecha_inicio: null,
          fecha_termino: taskFecha || null,
          colaborador: uid ? colName(uid) : ''
        })
        etapa.tareas.total += 1
        etapa.tareas.pendientes += 1
      })
        }
        return next
      })
      const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
      setDetalle(d)
      setTaskOpen(false)
      setTaskNombre('')
      setTaskDesc('')
      setTaskColabIds([''])
      setTaskFecha('')
      setTaskPrioridad('')
      setTaskEtapaId(null)
      const ename = getEtapaNameById(taskEtapaId)
      setToast({ visible: true, type: 'success', title: 'Tarea creada', message: `"${taskNombre.trim()}" creada en la etapa "${ename}".` })
    } catch (e) {
      const ename = getEtapaNameById(taskEtapaId)
      setToast({ visible: true, type: 'error', title: 'No se pudo crear la tarea', message: `Error creando "${taskNombre.trim() || 'Tarea'}" en "${ename}". ${e.message || 'Intenta nuevamente.'}` })
    } finally {
      setTaskSaving(false)
    }
  }


  const cerrarEtapa = async (eid) => {
    try {
      setClosingEtapaId(eid)
      await fetchAuth(`/api/jefe/proyectos/${id}/etapas/${eid}/cerrar/`, { method: 'POST' })
      const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
      setDetalle(d)
      const ename = getEtapaNameById(eid)
      setToast({ visible: true, type: 'success', title: 'Etapa cerrada', message: `Se cerró la etapa "${ename}".` })
    } catch (e) {
      const ename = getEtapaNameById(eid)
      setToast({ visible: true, type: 'error', title: 'No se pudo cerrar la etapa', message: `No se pudo cerrar "${ename}". ${e.message || 'Intenta nuevamente.'}` })
    } finally {
      setClosingEtapaId(null)
    }
  }

  const cerrarProyecto = async () => {
    try {
      setProjectClosing(true)
      await fetchAuth(`/api/jefe/proyectos/${id}/cerrar/`, { method: 'POST' })
      const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
      setDetalle(d)
      setToast({ visible: true, type: 'success', title: 'Proyecto cerrado', message: 'Se finalizó el proyecto.' })
    } catch (e) {
      setToast({ visible: true, type: 'error', title: 'No se pudo cerrar el proyecto', message: e.message || 'Intenta nuevamente.' })
    } finally {
      setProjectClosing(false)
    }
  }

  const reabrirEtapa = async (eid) => {
    try {
      setReopeningEtapaId(eid)
      await fetchAuth(`/api/jefe/proyectos/${id}/etapas/${eid}/reabrir/`, { method: 'POST' })
      const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
      setDetalle(d)
      const ename = getEtapaNameById(eid)
      setToast({ visible: true, type: 'success', title: 'Etapa reabierta', message: `Se reabrió la etapa "${ename}".` })
    } catch (e) {
      const ename = getEtapaNameById(eid)
      setToast({ visible: true, type: 'error', title: 'No se pudo reabrir la etapa', message: `No se pudo reabrir "${ename}". ${e.message || 'Intenta nuevamente.'}` })
    } finally {
      setReopeningEtapaId(null)
    }
  }

  const abrirEditarTarea = async (tid) => {
    try {
      setEditOpen(true)
      setEditLoading(true)
      setEditTaskId(tid)
      const detalleTarea = await fetchAuth(`/api/jefe/tareas/${tid}/detalle/`)
      setEditNombre(detalleTarea.nombre || '')
      const orig = String(detalleTarea.descripcion || '')
      let markers = ''
      try {
        const idx = orig.indexOf('[SOLICITUD_PLAZO]')
        if (idx > -1) {
          markers = orig.slice(idx)
        }
      } catch {}
      let cleaned = orig
      try { cleaned = cleaned.replace(/\[SOLICITUD_PLAZO\][\s\S]*$/, '') } catch {}
      try { cleaned = cleaned.replace(/\[[^\]]+\]/g, '') } catch {}
      try {
        cleaned = cleaned
          .replace(/\b[A-ZÁÉÍÓÚÑ_]{2,}=\S+/g, ' ')
          .replace(/(?:^|\s)([A-ZÁÉÍÓÚÑ_]+(?:\s+[A-ZÁÉÍÓÚÑ_]+)*)=\S+/g, ' ')
          .replace(/\s{2,}/g, ' ')
      } catch {}
      cleaned = cleaned.trim()
      setEditDesc(cleaned)
      setEditDescMarkers(markers)
      setEditFecha((detalleTarea.fecha_termino || '').slice(0,10))
      setEditPrioridad(detalleTarea.prioridad || '')
      setEditEstado(detalleTarea.estado || '')
      setEditColabId(String((detalleTarea.colaborador || {}).id_usuario || ''))
    } catch (e) {
      setToast({ visible: true, type: 'error', title: 'No se pudo cargar', message: e.message || 'Intenta nuevamente.' })
      setEditOpen(false)
    } finally {
      setEditLoading(false)
    }
  }

  const guardarEdicionTarea = async () => {
    try {
      if (!editTaskId) return
      setEditSaving(true)
      const finalDesc = [String(editDesc || '').trim(), String(editDescMarkers || '').trim()].filter(Boolean).join('\n').trim()
      const payload = {
        nombre: editNombre,
        descripcion: finalDesc || null,
        fecha_termino: editFecha || null,
        prioridad: editPrioridad || null,
        estado: editEstado || null,
      }
      if (editColabId === '') {
        
      } else if (editColabId === 'null') {
        payload.id_usuario_asignado = null
      } else {
        payload.id_usuario_asignado = parseInt(editColabId, 10)
      }
      await fetchAuth(`/api/jefe/tareas/${editTaskId}/actualizar/`, {
        method: 'POST',
        body: JSON.stringify(payload)
      })
      const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
      setDetalle(d)
      setEditOpen(false)
      setEditTaskId(null)
      setToast({ visible: true, type: 'success', title: 'Tarea actualizada', message: `Se actualizaron los cambios en "${editNombre || 'Tarea'}".` })
    } catch (e) {
      setToast({ visible: true, type: 'error', title: 'No se pudo actualizar la tarea', message: `Error al actualizar "${editNombre || 'Tarea'}". ${e.message || 'Intenta nuevamente.'}` })
    } finally {
      setEditSaving(false)
    }
  }

  const abrirEliminarTarea = (tid) => {
    setDeleteOpen(true)
    setDeletingId(tid)
  }

  const confirmarEliminarTarea = async () => {
    try {
      if (!deletingId) return
      setDeleting(true)
      const tname = getTaskNameById(deletingId)
      await fetchAuth(`/api/jefe/tareas/${deletingId}/eliminar/`, { method: 'DELETE' })
      const d = await fetchAuth(`/api/jefe/proyectos/${id}/detalle/`)
      setDetalle(d)
      setDeleteOpen(false)
      setDeletingId(null)
      setToast({ visible: true, type: 'success', title: 'Tarea eliminada', message: `Se eliminó "${tname}".` })
    } catch (e) {
      const tname = getTaskNameById(deletingId)
      setToast({ visible: true, type: 'error', title: 'No se pudo eliminar la tarea', message: `No se pudo eliminar "${tname}". ${e.message || 'Intenta nuevamente.'}` })
    } finally {
      setDeleting(false)
    }
  }


  

  

  if (loading) return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 rounded-full bg-indigo-100 flex items-center justify-center mx-auto mb-4">
          <FaProjectDiagram className="text-indigo-500 text-2xl animate-pulse" />
        </div>
        <p className="text-slate-700 text-lg font-medium">Cargando detalle del proyecto...</p>
      </div>
    </div>
  )
  if (error) return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
      <div className="bg-red-50 border border-red-200 rounded-2xl p-8 max-w-md text-center">
        <div className="text-red-600 text-5xl mb-4">⚠️</div>
        <h3 className="text-red-800 text-xl font-bold mb-2">Error al cargar</h3>
        <p className="text-red-600">{error}</p>
      </div>
    </div>
  )

  const estadoUI = toUIEstado(detalle?.estado)

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-slate-100">
      <div className="max-w-7xl mx-auto p-6">
        <AnimatePresence>
          {toast.visible && (
            <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50">
              <motion.div
                initial={{ opacity: 0, y: -16, scale: 0.98 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -16, scale: 0.98 }}
                transition={{ duration: 0.22, ease: 'easeOut' }}
              >
                <div className={`flex items-start gap-3 rounded-xl border shadow-lg px-4 py-3 ${toast.type === 'success' ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'}`}>
                  <div className={`${toast.type === 'success' ? 'text-emerald-600' : 'text-red-600'} text-xl`}>
                    {toast.type === 'success' ? <FaCheckCircle /> : <FaExclamationCircle />}
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-slate-800">{toast.title}</p>
                    <p className="text-sm text-slate-600">{toast.message}</p>
                  </div>
                  <button
                    onClick={() => setToast(prev => ({ ...prev, visible: false }))}
                    className="text-slate-400 hover:text-slate-600"
                    aria-label="Cerrar notificación"
                  >
                    <FaTimes />
                  </button>
                </div>
              </motion.div>
            </div>
          )}
        </AnimatePresence>
        <div className="mb-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200 transition-colors"
          >
            <FaChevronLeft /> Volver
          </button>
        </div>

        <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-3xl shadow-xl p-6 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 bg-white/10 rounded-full -mr-24 -mt-24" />
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-white/20 backdrop-blur-sm p-3 rounded-2xl shadow">
                <FaProjectDiagram className="text-white text-2xl" />
              </div>
              <div>
                <h1 className="text-3xl lg:text-4xl font-bold tracking-tight">{detalle?.nombre_proyecto || 'Proyecto'}</h1>
                <p className="text-white/80 mt-1 max-w-3xl line-clamp-2">{detalle?.descripcion || 'Sin descripción'}</p>
              </div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full font-semibold text-sm">{estadoUI}</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-200">
            <div className="flex items-center gap-3 mb-3">
              <FaCalendar className="text-slate-400" />
              <h3 className="text-slate-800 font-bold">Fechas</h3>
            </div>
            <div className="space-y-2 text-slate-700">
              {detalle?.fecha_inicio && (
                <p><span className="font-semibold">Fecha de inicio planificada:</span> {formatDate(detalle.fecha_inicio)}</p>
              )}
              {detalle?.fecha_inicio_real && (
                <p><span className="font-semibold">Fecha de inicio real:</span> {formatDate(detalle.fecha_inicio_real)}</p>
              )}
              {detalle?.fecha_fin && (
                <p><span className="font-semibold">Fecha de término planificado:</span> {formatDate(detalle.fecha_fin)}</p>
              )}
              {detalle?.fecha_fin_real && (
                <p><span className="font-semibold">Fecha de término real:</span> {formatDate(detalle.fecha_fin_real)}</p>
              )}
              {detalle?.fecha_inicio_real && detalle?.fecha_fin && (() => {
                const start = toDate(detalle.fecha_inicio_real)
                const end = toDate(detalle.fecha_fin)
                if (!start || !end || end <= start) return null
                const last = toDate(detalle.fecha_fin_real || detalle.fecha_ultima_tarea_completada)
                const total = Math.max(1, daysBetween(start, end))
                const elapsedRaw = daysBetween(start, last || start)
                const elapsed = Math.min(Math.max(0, elapsedRaw ?? 0), total)
                const percent = Math.round((elapsed / total) * 100)
                const r = 48
                const c = 2 * Math.PI * r
                const dash = (c * percent) / 100
                const rem = c - dash
                return (
                  <div className="mt-3 bg-slate-50 rounded-xl p-3 border border-slate-200">
                    <div className="flex items-center gap-2 mb-2 text-slate-700 text-sm font-semibold"><FaChartPie className="text-slate-500" /> Avance real vs fin planificado</div>
                    <div className="flex items-center gap-4">
                      <svg width="120" height="120" viewBox="0 0 120 120" className="shrink-0">
                        <g transform="translate(60,60) rotate(-90)">
                          <circle r={r} cx="0" cy="0" fill="none" stroke="#e2e8f0" strokeWidth="16" />
                          <circle r={r} cx="0" cy="0" fill="none" stroke="#6366f1" strokeWidth="16" strokeDasharray={`${dash} ${rem}`} strokeLinecap="round" />
                        </g>
                      </svg>
                      <div className="flex-1">
                        <div className="text-slate-800 text-2xl font-bold">{percent}%</div>
                        <div className="mt-1 text-xs text-slate-600">{elapsed} días de {total} días</div>
                        <div className="mt-2 flex items-center gap-2">
                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-indigo-100 text-indigo-700 border border-indigo-200">Avance real</span>
                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 border">Restante planificado</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })()}
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-200">
            <div className="flex items-center gap-3 mb-3">
              <FaUsers className="text-slate-400" />
              <h3 className="text-slate-800 font-bold">Colaboradores</h3>
            </div>
          {detalle?.colaboradores?.length ? (
            <ul className="divide-y divide-slate-200">
              {detalle.colaboradores.map(c => (
                <li key={c.id_usuario} className="py-2 flex items-center justify-between">
                  <span className="font-medium text-slate-800">{c.nombre}</span>
                  <div className="flex items-center gap-3">
                    <span className="text-slate-500 text-sm">{c.email}</span>
                    {(() => {
                      const desc = String(detalle?.descripcion || '');
                      const accepted = new RegExp(`\\[INVITACION_USUARIO:${String(c.id_usuario)}:ACEPTADA\\]`).test(desc);
                      const isRejected = new RegExp(`\\[INVITACION_USUARIO:${String(c.id_usuario)}:RECHAZADA\\]`).test(desc);
                      const label = accepted ? 'Aceptado' : (isRejected ? 'Rechazado' : (String(c.estado || '').toUpperCase() === 'INACTIVO' ? 'Rechazado' : (String(c.estado || '').toUpperCase() === 'ACTIVO' ? 'Aceptado' : 'Pendiente')));
                      const cls = accepted ? 'bg-green-100 text-green-700' : (isRejected ? 'bg-blue-100 text-blue-700' : (String(c.estado || '').toUpperCase() === 'ACTIVO' ? 'bg-green-100 text-green-700' : (String(c.estado || '').toUpperCase() === 'INACTIVO' ? 'bg-blue-100 text-blue-700' : 'bg-orange-100 text-orange-700')));
                      return (
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${cls}`}>{label}</span>
                      );
                    })()}
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-slate-600">Sin colaboradores</p>
          )}

            <div className="mt-4 pt-4 border-t border-slate-200">
              <div className="flex items-end gap-3">
                <div className="flex-1">
                  <label className="text-sm font-semibold text-slate-700">Asignar colaborador</label>
                  <select
                    value={nuevoColabId}
                    onChange={(e) => setNuevoColabId(e.target.value)}
                    className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800"
                  >
                    <option value="">Seleccionar colaborador...</option>
                    {(() => {
                      const existentes = (detalle?.colaboradores || []).map(c => String(c.id_usuario))
                      const disponibles = (colabs || []).filter(c => !existentes.includes(String(c.id_usuario)))
                      return disponibles.map(c => (
                        <option key={c.id_usuario} value={c.id_usuario}>{c.nombre} — {c.email}</option>
                      ))
                    })()}
                  </select>
                </div>
                <button
                  onClick={abrirConfirmacion}
                  disabled={!nuevoColabId}
                  className="px-4 py-2 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 disabled:opacity-50"
                >
                  Mandar solicitud
                </button>
              </div>
            </div>
          </div>
        </div>

        {detalle?.metricas && (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-6">
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaTasks /> Total Tareas</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_totales}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaClock /> En Revisión</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_en_revision}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaCheckCircle /> Completadas</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_completadas}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaTasks /> Pendientes</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_pendientes}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaBan /> Canceladas</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_canceladas}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaUsers /> Colaboradores</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.colaboradores_count}</div>
            </div>
          </div>
        )}

        <div className="mt-8">
          <div className="bg-gradient-to-b from-white to-slate-50 rounded-2xl shadow-xl p-6 border border-slate-200">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-slate-800 font-bold">Distribución de Proyecto</h3>
            </div>
            {detalle?.etapas?.length ? (
              <ul className="space-y-3">
                {detalle.etapas.map(e => {
                  const isCurrent = String(detalle?.current_etapa_id) === String(e.id_etapa)
                  const isActive = String(e.estado || '').toLowerCase() === 'activa'
                  const hasItems = Array.isArray(e.items) && e.items.length > 0
                  const isAsignarEnabled = isCurrent && isActive
                  return (
                  <li key={e.id_etapa} className={`bg-white rounded-xl p-4 border border-slate-200 shadow-sm hover:shadow-md hover:border-indigo-200 transition ${isCurrent ? 'ring-1 ring-indigo-100' : ''}`}>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <p className="font-semibold text-slate-800">{e.nombre}</p>
                        <button
                          onClick={() => { setTaskEtapaId(e.id_etapa); setTaskOpen(true); }}
                          title="Agregar tarea"
                          aria-label="Agregar tarea"
                          className={`inline-flex items-center gap-2 h-9 pl-2 pr-3 rounded-full font-semibold transition bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-sm hover:shadow-md ring-1 ring-indigo-300`}
                        >
                          <span className={`inline-flex items-center justify-center h-6 w-6 rounded-full ${
                            'bg-white/20 border border-white/30 text-white'
                          }`}>
                            <FaPlus className="text-xs" />
                          </span>
                          <span className="text-[13px] tracking-wide">Agregar tarea</span>
                        </button>
                      </div>
                      <div className="flex items-center gap-2">
                        {isCurrent && (
                          <span className="px-2 py-1 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-700 border">Actual</span>
                        )}
                        {(isCurrent && isActive) && (
                          <span className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">Activa</span>
                        )}
                        {(!isCurrent && String(e.estado || '').toLowerCase() === 'completada') && (
                          <span className="px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700">Completada</span>
                        )}
                        {String(e.estado || '').toLowerCase() === 'completada' && (
                          <button
                            type="button"
                            onClick={() => reabrirEtapa(e.id_etapa)}
                            disabled={reopeningEtapaId === e.id_etapa}
                            className={`inline-flex items-center gap-2 px-3 h-9 rounded-xl text-xs font-semibold transition-all ${
                              reopeningEtapaId === e.id_etapa
                                ? 'bg-slate-200 text-slate-500 border border-slate-300'
                                : 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-md hover:from-orange-600 hover:to-orange-700 ring-1 ring-orange-300'
                            }`}
                            aria-label="Reabrir etapa"
                          >
                            <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-white/25 text-white">
                              <FaUndo className="text-[10px]" />
                            </span>
                            <span>{reopeningEtapaId === e.id_etapa ? 'Reabriendo...' : 'Reabrir etapa'}</span>
                          </button>
                        )}
                        {(() => {
                          const isCurrent = String(detalle?.current_etapa_id) === String(e.id_etapa)
                          const isActive = String(e.estado || '').toLowerCase() === 'activa'
                          const allDone = (e.tareas?.total || 0) > 0 && (e.tareas?.pendientes || 0) === 0 && (e.tareas?.en_progreso || 0) === 0
                          const isLast = String(e.slug || '').toLowerCase() === 'cierre' || String(e.nombre || '').trim().toLowerCase() === 'cierre' || Number(e.orden) === 6
                          return (isCurrent && isActive && allDone)
                        })() && (
                          <button
                            type="button"
                            onClick={() => cerrarEtapa(e.id_etapa)}
                            disabled={closingEtapaId === e.id_etapa}
                            className={`inline-flex items-center gap-2 px-3 h-9 rounded-xl text-xs font-semibold transition-all ${
                              closingEtapaId === e.id_etapa
                                ? 'bg-slate-200 text-slate-500 border border-slate-300'
                                : 'bg-gradient-to-r from-green-500 to-green-600 text-white shadow-md hover:from-green-600 hover:to-green-700 ring-1 ring-green-300'
                            }`}
                            aria-label={'Cerrar etapa'}
                          >
                            <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-white/25 text-white">
                              <FaCheckCircle className="text-[10px]" />
                            </span>
                            <span>{closingEtapaId === e.id_etapa ? 'Cerrando...' : 'Cerrar etapa'}</span>
                          </button>
                        )}
                        {(() => {
                          const isCurrent = String(detalle?.current_etapa_id) === String(e.id_etapa)
                          const isActive = String(e.estado || '').toLowerCase() === 'activa'
                          const isCompleted = String(e.estado || '').toLowerCase() === 'completada'
                          const allDone = (e.tareas?.total || 0) > 0 && (e.tareas?.pendientes || 0) === 0 && (e.tareas?.en_progreso || 0) === 0
                          const isLast = String(e.slug || '').toLowerCase() === 'cierre' || String(e.nombre || '').trim().toLowerCase() === 'cierre' || Number(e.orden) === 6
                          return (isCurrent && allDone && isLast && (isActive || isCompleted))
                        })() && (
                          <button
                            type="button"
                            onClick={cerrarProyecto}
                            disabled={projectClosing}
                            className={`inline-flex items-center gap-2 px-3 h-9 rounded-xl text-xs font-semibold transition-all ${
                              projectClosing
                                ? 'bg-slate-200 text-slate-500 border border-slate-300'
                                : 'bg-gradient-to-r from-purple-600 to-violet-600 text-white shadow-md hover:from-purple-700 hover:to-violet-700 ring-1 ring-purple-300'
                            }`}
                            aria-label={'Cerrar proyecto'}
                          >
                            <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-white/25 text-white">
                              <FaCheckCircle className="text-[10px]" />
                            </span>
                            <span>{projectClosing ? 'Cerrando...' : 'Cerrar proyecto'}</span>
                          </button>
                        )}
                        {(isCurrent && hasItems) && (
                          <button
                            type="button"
                            onClick={() => setEtapasCollapsed(prev => ({ ...prev, [e.id_etapa]: !prev[e.id_etapa] }))}
                            className={`inline-flex items-center gap-2 px-3 h-9 rounded-xl text-xs font-semibold transition-all ${
                              etapasCollapsed[e.id_etapa]
                                ? 'bg-gradient-to-r from-indigo-500 to-indigo-600 text-white shadow-md hover:from-indigo-600 hover:to-indigo-700 ring-1 ring-indigo-300'
                                : 'bg-white text-indigo-700 border border-indigo-200 hover:bg-indigo-50 ring-1 ring-indigo-100'
                            }`}
                            aria-label={etapasCollapsed[e.id_etapa] ? 'Mostrar tareas' : 'Ocultar tareas'}
                          >
                            <span className={`inline-flex items-center justify-center h-5 w-5 rounded-full ${
                              etapasCollapsed[e.id_etapa] ? 'bg-white/25 text-white' : 'bg-indigo-100 text-indigo-700'
                            }`}>
                              {etapasCollapsed[e.id_etapa] ? <FaChevronDown className="text-[10px]" /> : <FaChevronUp className="text-[10px]" />}
                            </span>
                            <span>{etapasCollapsed[e.id_etapa] ? 'Mostrar tareas' : 'Ocultar tareas'}</span>
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="mt-2 flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-slate-100 text-slate-700 border">
                          <FaTag className="text-[10px]" />
                          <span>Slug: {e.slug}</span>
                        </span>
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-slate-100 text-slate-700 border">
                          <FaListOl className="text-[10px]" />
                          <span>Orden: {e.orden}</span>
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-700 border">
                          <FaTasks className="text-[10px]" />
                          <span>Tareas: {e.tareas?.total || 0}</span>
                        </span>
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-700 border">
                          <FaClock className="text-[10px]" />
                          <span>Pendientes: {e.tareas?.pendientes || 0}</span>
                        </span>
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-700 border">
                          <FaChartPie className="text-[10px]" />
                          <span>Progreso: {e.tareas?.en_progreso || 0}</span>
                        </span>
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-700 border">
                          <FaCheckCircle className="text-[10px]" />
                          <span>Completadas: {e.tareas?.completadas || 0}</span>
                        </span>
                      </div>
                    </div>
                  {!etapasCollapsed[e.id_etapa] && Array.isArray(e.items) && e.items.length > 0 && (
                    <div className="mt-3 w-full">
                      <ul className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-200">
                        {e.items.map((t) => (
                          <li key={t.id_tarea} className="px-3 py-3">
                            <div className="flex items-center justify-between">
                              <div className="font-medium text-slate-800 truncate">{t.nombre || 'Tarea'}</div>
                              <div className="flex items-center gap-2">
                                {t.prioridad && (
                                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold border ${
                                    t.prioridad === 'Alta' ? 'bg-red-100 text-red-700 border-red-200' :
                                    t.prioridad === 'Media' ? 'bg-yellow-100 text-yellow-700 border-yellow-200' :
                                    'bg-green-100 text-green-700 border-green-200'
                                  }`}>{t.prioridad}</span>
                                )}
                                <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                                  String(t.estado || '').toLowerCase().includes('complet') || String(t.estado || '').toLowerCase().includes('aprob') ? 'bg-green-100 text-green-700' :
                                  String(t.estado || '').toLowerCase().includes('revision') ? 'bg-yellow-100 text-yellow-700' :
                                  String(t.estado || '').toLowerCase().includes('progreso') ? 'bg-indigo-100 text-indigo-700' :
                                  String(t.estado || '').toLowerCase().includes('pend') ? 'bg-amber-100 text-amber-700' :
                                  String(t.estado || '').toLowerCase().includes('cancel') || String(t.estado || '').toLowerCase().includes('rechaz') ? 'bg-red-100 text-red-700' :
                                  'bg-slate-100 text-slate-700'
                                }`}>{t.estado}</span>
                                <button
                                  type="button"
                                  onClick={() => abrirEditarTarea(t.id_tarea)}
                                  className="inline-flex items-center justify-center h-8 w-8 rounded-xl bg-blue-50 text-blue-700 hover:bg-blue-100 border border-blue-200"
                                  aria-label="Editar tarea"
                                >
                                  <FaEdit className="text-sm" />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => abrirEliminarTarea(t.id_tarea)}
                                  className="inline-flex items-center justify-center h-8 w-8 rounded-xl bg-red-50 text-red-700 hover:bg-red-100 border border-red-200"
                                  aria-label="Eliminar tarea"
                                >
                                  <FaTrash className="text-sm" />
                                </button>
                              </div>
                            </div>
                              <div className="mt-1 text-xs text-slate-600 flex items-center justify-between">
                                <span>{t.colaborador || 'Sin asignar'}</span>
                                <div className="flex items-center gap-2">
                                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 border">
                                    <FaCalendar className="text-[10px]" />
                                    <span>Inicio: {t.fecha_inicio ? formatDate(t.fecha_inicio) : '-'}</span>
                                  </span>
                                   <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 border">
                                     <FaClock className="text-[10px]" />
                                     <span>Entrega: {t.fecha_entrega_inicial ? formatDate(t.fecha_entrega_inicial) : (t.fecha_termino ? formatDate(t.fecha_termino) : '-')}</span>
                                   </span>
                                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 border">
                                    <FaHourglassHalf className="text-[10px]" />
                                    <span>Plazo: {t.fecha_plazo ? formatDate(t.fecha_plazo) : '-'}</span>
                                  </span>
                                  {(() => {
                                    const ep = String(t.estado_plazo || '').toLowerCase()
                                    const cls = ep.includes('aprob') ? 'bg-green-100 text-green-700' : ep.includes('rechaz') ? 'bg-red-100 text-red-700' : ep.includes('pend') ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-700'
                                    const label = t.estado_plazo ? t.estado_plazo : '-'
                                    return (
                                      <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${cls}`}>{label}</span>
                                    )
                                  })()}
                                </div>
                              </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              )})}
              </ul>
          ) : (
            <p className="text-slate-600">Sin etapas creadas</p>
            )}
          </div>
        </div>
      {confirmOpen && (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full border border-slate-200">
            <h4 className="text-slate-800 font-bold mb-2">Confirmar envío</h4>
            <p className="text-slate-600 mb-4">¿Enviar solicitud de colaboración a {colabs.find(c => String(c.id_usuario)===String(nuevoColabId))?.nombre}?</p>
            <div className="flex justify-end gap-3">
              <button onClick={cerrarConfirmacion} className="px-4 py-2 rounded-xl bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200">Cancelar</button>
              <button onClick={enviarSolicitud} disabled={agregando} className="px-4 py-2 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 disabled:opacity-50">{agregando ? 'Enviando...' : 'Enviar solicitud'}</button>
            </div>
          </div>
        </div>
      )}
      
      {taskOpen && (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full border border-slate-200">
            <h4 className="text-slate-800 font-bold mb-4">Nueva tarea</h4>
            <div className="space-y-3">
              <div>
                <label className="text-sm font-semibold text-slate-700">Nombre</label>
                <input value={taskNombre} onChange={(e) => setTaskNombre(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800" />
              </div>
              <div>
                <label className="text-sm font-semibold text-slate-700">Descripción</label>
                <textarea value={taskDesc} onChange={(e) => setTaskDesc(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800" />
              </div>
              <div>
                <div className="flex items-center justify-between">
                  <label className="text-sm font-semibold text-slate-700">Asignar colaborador</label>
                  <button
                    type="button"
                    onClick={() => setTaskColabIds([...taskColabIds, ''])}
                    className="inline-flex items-center justify-center h-7 w-7 rounded-full bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm ring-1 ring-indigo-300"
                    aria-label="Agregar colaborador"
                  >
                    <FaPlus className="text-sm" />
                  </button>
                </div>
                <div className="space-y-2 mt-2">
                  {taskColabIds.map((val, idx) => {
                    const activos = (detalle?.colaboradores || []).filter(c => String(c.estado || '').toUpperCase() === 'ACTIVO')
                    const usados = taskColabIds.filter(v => v).map(v => String(v))
                    const disponibles = activos.filter(c => !usados.includes(String(c.id_usuario)) || String(val) === String(c.id_usuario))
                    return (
                      <div key={idx} className="flex items-center gap-2">
                        <select
                          value={val}
                          onChange={(e) => {
                            const next = [...taskColabIds];
                            next[idx] = e.target.value;
                            setTaskColabIds(next);
                          }}
                          className="flex-1 border border-slate-300 rounded-xl px-3 py-2 text-slate-800 focus:ring-2 focus:ring-indigo-300 outline-none"
                        >
                          <option value="">Sin asignar</option>
                          {disponibles.map(c => (
                            <option key={c.id_usuario} value={c.id_usuario}>{c.nombre} — {c.email}</option>
                          ))}
                        </select>
                        {taskColabIds.length > 1 && (
                          <button
                            type="button"
                            onClick={() => {
                              const next = [...taskColabIds];
                              next.splice(idx, 1);
                              setTaskColabIds(next.length ? next : ['']);
                            }}
                            className="inline-flex items-center justify-center h-9 w-9 rounded-xl bg-red-50 text-red-700 hover:bg-red-100 border border-red-200"
                            aria-label="Eliminar colaborador"
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
              <div>
                <label className="text-sm font-semibold text-slate-700">Fecha límite</label>
                <input type="date" value={taskFecha} onChange={(e) => setTaskFecha(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800" />
              </div>
              <div>
                <label className="text-sm font-semibold text-slate-700">Prioridad</label>
                <select value={taskPrioridad} onChange={(e) => setTaskPrioridad(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800">
                  <option value="">Sin prioridad</option>
                  <option value="Alta">Alta</option>
                  <option value="Media">Media</option>
                  <option value="Baja">Baja</option>
                </select>
                {taskPrioridad && (
                  <div className="mt-2">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border ${
                      taskPrioridad === 'Alta' ? 'bg-red-100 text-red-700 border-red-200' :
                      taskPrioridad === 'Media' ? 'bg-yellow-100 text-yellow-700 border-yellow-200' :
                      'bg-green-100 text-green-700 border-green-200'
                    }`}>
                      {taskPrioridad === 'Alta' ? 'Alta' : taskPrioridad === 'Media' ? 'Media' : 'Baja'}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-4">
              <button onClick={() => setTaskOpen(false)} className="px-4 py-2 rounded-xl bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200">Cancelar</button>
              <button onClick={crearTareaEnEtapa} disabled={taskSaving || !taskNombre.trim()} className="px-4 py-2 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 disabled:opacity-50">{taskSaving ? 'Creando...' : 'Crear'}</button>
            </div>
          </div>
        </div>
      )}

      {editOpen && (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full border border-slate-200">
            <h4 className="text-slate-800 font-bold mb-4">Editar tarea</h4>
            {editLoading ? (
              <p className="text-slate-600">Cargando...</p>
            ) : (
              <div className="space-y-3">
                <div>
                  <label className="text-sm font-semibold text-slate-700">Nombre</label>
                  <input value={editNombre} onChange={(e) => setEditNombre(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800" />
                </div>
                <div>
                  <label className="text-sm font-semibold text-slate-700">Descripción</label>
                  <textarea value={editDesc} onChange={(e) => setEditDesc(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800" />
                </div>
                <div>
                  <label className="text-sm font-semibold text-slate-700">Fecha límite</label>
                  <input type="date" value={editFecha} onChange={(e) => setEditFecha(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800" />
                </div>
                <div>
                  <label className="text-sm font-semibold text-slate-700">Prioridad</label>
                  <select value={editPrioridad} onChange={(e) => setEditPrioridad(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800">
                    <option value="">Sin prioridad</option>
                    <option value="Alta">Alta</option>
                    <option value="Media">Media</option>
                    <option value="Baja">Baja</option>
                  </select>
                </div>
                <div>
                  <label className="text-sm font-semibold text-slate-700">Estado</label>
                  <select value={editEstado} onChange={(e) => setEditEstado(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800">
                    <option value="">Sin cambios</option>
                    <option value="Pendiente">Pendiente</option>
                    <option value="En Progreso">En Progreso</option>
                    <option value="En Revision">En Revision</option>
                    <option value="Completado">Completado</option>
                    <option value="Cancelado">Cancelado</option>
                  </select>
                </div>
                <div>
                  <label className="text-sm font-semibold text-slate-700">Asignación</label>
                  <select value={editColabId} onChange={(e) => setEditColabId(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-xl px-3 py-2 text-slate-800">
                    <option value="">Sin cambios</option>
                    <option value="null">Sin asignar</option>
                    {(() => {
                      const desc = String(detalle?.descripcion || '')
                      const aceptados = (detalle?.colaboradores || []).filter(c => new RegExp(`\\[INVITACION_USUARIO:${String(c.id_usuario)}:ACEPTADA\\]`).test(desc))
                      return aceptados.map(c => (
                        <option key={c.id_usuario} value={String(c.id_usuario)}>{c.nombre} — {c.email}</option>
                      ))
                    })()}
                  </select>
                </div>
              </div>
            )}
            <div className="flex justify-end gap-3 mt-4">
              <button onClick={() => setEditOpen(false)} className="px-4 py-2 rounded-xl bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200">Cancelar</button>
              <button onClick={guardarEdicionTarea} disabled={editSaving || !editNombre.trim()} className="px-4 py-2 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 disabled:opacity-50">{editSaving ? 'Guardando...' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}

      {deleteOpen && (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full border border-slate-200">
            <h4 className="text-slate-800 font-bold mb-2">Eliminar tarea</h4>
            <p className="text-slate-600 mb-4">¿Seguro que deseas eliminar esta tarea?</p>
            <div className="flex justify-end gap-3">
              <button onClick={() => { setDeleteOpen(false); setDeletingId(null); }} className="px-4 py-2 rounded-xl bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200">Cancelar</button>
              <button onClick={confirmarEliminarTarea} disabled={deleting} className="px-4 py-2 rounded-xl bg-red-600 text-white font-semibold hover:bg-red-700 disabled:opacity-50">{deleting ? 'Eliminando...' : 'Eliminar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
  )
}
